var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"3.84967","width":"20.3","height":"0.299996","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.2855 0.250061H17.6001L20.3146 4.00001L17.6001 7.74996H20.2855L23 4.00001L20.2855 0.250061Z","fill":"currentColor","key":1})]);
}

ArrowInline.defaultProps = {"width":"23","height":"8","viewBox":"0 0 23 8","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
